import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import { getUid } from '../../utils/helper';
import './news.scss';

const NEWS_ARTICLE_STORAGE = 'strikers_news_article';

class NewsDetail extends Component {
    constructor(props) {
        super(props);
        this.state = { article: null };
    }

    componentDidMount() {
        this.resolveArticle();
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            this.resolveArticle();
        }
    }

    resolveArticle() {
        const { location, history } = this.props;
        let article = location.state && location.state.article;
        if (!article) {
            try {
                const raw = sessionStorage.getItem(NEWS_ARTICLE_STORAGE);
                if (raw) article = JSON.parse(raw);
            } catch (e) {
                /* ignore */
            }
        }
        if (!article || !article.url) {
            const uid = getUid();
            history.replace({
                pathname: '/news',
                search: uid ? `?uid=${uid}` : '',
            });
            return;
        }
        this.setState({ article });
    }

    goBack = () => {
        const { history } = this.props;
        const uid = getUid();
        const newsPath = {
            pathname: '/news',
            search: uid ? `?uid=${uid}` : '',
        };
        if (window.history.length > 1) {
            history.goBack();
        } else {
            history.push(newsPath);
        }
    };

    render() {
        const { article } = this.state;
        const { selectedLanguage } = this.props;
        const rtl = selectedLanguage === 'ar';

        if (!article) {
            return null;
        }

        return (
            <div className={rtl ? 'news-page news-page-rtl news-detail-page' : 'news-page news-detail-page'}>
                <div className="news-detail-topbar">
                    <button type="button" className="news-detail-back" onClick={this.goBack}>
                        <span className="news-detail-back-arrow" aria-hidden>
                            ←
                        </span>
                        <FormattedMessage id="news_back" defaultMessage="Back to news" />
                    </button>
                </div>

                <div className="news-shell">
                    <article className="news-detail-card">
                        {article.urlToImage ? (
                            <div className="news-detail-hero">
                                <img src={article.urlToImage} alt="" className="news-detail-hero-img" />
                            </div>
                        ) : null}

                        <div className="news-detail-body">
                            {article.source ? (
                                <span className="news-detail-source">{article.source}</span>
                            ) : null}
                            <h2 className="news-detail-title">{article.title}</h2>
                            {article.publishedAt ? (
                                <time className="news-detail-time" dateTime={article.publishedAt}>
                                    {article.publishedAt}
                                </time>
                            ) : null}
                            {article.description ? (
                                <div className="news-detail-desc">
                                    {article.description.split(/\n+/).map((para, i) => (
                                        <p key={i}>{para}</p>
                                    ))}
                                </div>
                            ) : null}

                            <p className="news-detail-notice">
                                <FormattedMessage
                                    id="news_external_notice"
                                    defaultMessage="The full story is published by the source below. You can open it in a new tab."
                                />
                            </p>

                            <a
                                className="news-detail-cta"
                                href={article.url}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FormattedMessage
                                    id="news_read_original"
                                    defaultMessage="Read full article"
                                />
                            </a>
                        </div>
                    </article>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    selectedLanguage: state.HeaderReducer.selectedLanguage,
});

export default connect(mapStateToProps, null)(withRouter(NewsDetail));
